<template>
    <nav aria-label="Page navigation example">
        <ul class="pagination justify-content-center mb-1">
            <li :class="{
                'page-item': true,
                'disabled': !hasPreviousPage
            }">
                <a href="javascript: void(0);" class="page-link" @click="goToPage($event, 1)">
                    <i class="fa fa-fast-backward"></i>
                </a>
            </li>
            <li :class="{
                'page-item': true,
                'disabled': !hasPreviousPage
            }">
                <a href="javascript: void(0);" class="page-link" @click="goToPrevious">
                    <i class="fa fa-angle-left"></i>
                </a>
            </li>
            <li v-for="(page, index) in pagesList"
                :key="index"
                :class="{
                    'page-item': true,
                    'active': value === page.pageNumber
                }">
                <a class="page-link" href="javascript: void(0);" @click="goToPage($event, page.pageNumber)">
                    {{page.display}}
                </a>
            </li>

            <li :class="{
                'page-item': true,
                'disabled': !hasNextPage
            }">
                <a href="javascript: void(0);" class="page-link" @click="goToNext">
                    <i class="fa fa-angle-right"></i>
                </a>
            </li>
            <li :class="{
                'page-item': true,
                'disabled': !hasNextPage
            }">
                <a href="javascript: void(0);" class="page-link" @click="goToPage($event, totalPages)">
                    <i class="fa fa-fast-forward"></i>
                </a>
            </li>
        </ul>
        <template v-if="totalPages > 0">
            <center><p>Page {{ value }} of {{ totalPages }}</p></center>
        </template>
    </nav>
</template>

<script>
export default {
    'name': 'pagination-component',
    'props': {
        'value': {
            'type': Number,
            'required': true
        },
        'totalPages': {
            'type': Number,
            'required': true
        },
        'scrollPosition': {
            'type': Number,
            'default': 0
        }
    },
    'computed': {
        hasNextPage () {
            return this.value < this.totalPages;
        },
        hasPreviousPage () {
            return this.value > 1;
        },
        needsTruncate () {
            return this.totalPages > 7;
        },
        needsToShift () {
            let shiftCondition = this.value > 3 && this.value < this.totalPages - 3;
            return this.totalPages > 7 && shiftCondition;
        },
        pagesList () {
            let list = [];

            if (this.needsTruncate) {
                if (this.needsToShift) {
                    for (let i = this.value - 3; i < this.value + 4; i++) {
                        list.push({
                            'display': i + 1,
                            'pageNumber': i + 1
                        });
                    }
                } else if (this.value < 4) {
                    for (let i = 0; i < 7; i++) {
                        list.push({
                            'display': i + 1,
                            'pageNumber': i + 1
                        });
                    }
                } else {
                    for (let i = this.totalPages - 7; i < this.totalPages; i++) {
                        list.push({
                            'display': i + 1,
                            'pageNumber': i + 1
                        });
                    }
                }
            } else {
                for (let i = 0; i < this.totalPages; i++) {
                    list.push({
                        'display': i + 1,
                        'pageNumber': i + 1
                    });
                }
            }

            return list;
        }
    },
    'methods': {
        goToPage (event, pageNumber) {
            if (this.value !== pageNumber) {
                this.scrollTop();
                this.$emit('input', pageNumber);
            }
        },
        goToPrevious (event) {
            this.scrollTop();
            this.$emit('input', this.value - 1);
        },
        goToNext (event) {
            this.scrollTop();
            this.$emit('input', this.value + 1);
        },
        scrollTop () {
            document.body.scrollTop = this.scrollPosition; // For Safari
            document.documentElement.scrollTop = this.scrollPosition; // For Chrome, Firefox, IE and Opera
            event.target.blur();
        }
    }
};
</script>

<style>
li.page-item.disabled {
    cursor: not-allowed;
    opacity: .5;
}

li.page-item.active .page-link{
    cursor: default;
}
</style>
